import { ItemTop } from './ItemTop';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import { ItemTop10, ResponseTop10 } from '@/types/friendCup';

export const TableTop10 = ({ top }: { top: ResponseTop10 }) => {
  const { isDesktop } = useIsDesktop();

  return (
    <div className="w-[calc(100%+2rem)] -left-4 relative lg:left-auto lg:w-auto lg:mt-4">
      <div className="px-4 lg:px-0">
        <div className="flex text-gdt-gray-4 font-bold text-xs lg:text-sm h-14 pt-2 lg:pt-0 items-center lg:h-14 lg:items-end bg-gdt-gray-7 lg:bg-white lg:rounded-t-lg">
          <p className="w-14 lg:w-[104px] text-center">
            {isDesktop ? 'Posición' : 'Pos'}
          </p>
          <p className="flex-1 pl-1">Equipo</p>
          <p className="w-[87px] lg:w-[183px] text-center">Puntos</p>
        </div>
      </div>

      <div className="lg:h-auto bg-white overflow-hidden lg:rounded-b-lg">
        {top &&
          top?.map((team: ItemTop10, index: number) => {
            return (
              <ItemTop key={`${index} ${team.id} ${team.puesto}`} team={team} />
            );
          })}
      </div>
    </div>
  );
};
